<template>
    <div class="page-container" :style="bg">
        <div class="page-container__wrapper">
            <slot/>
        </div>
    </div>
</template>

<script>
    import VueTypes from "vue-types"

    export default {
        props: {
            img: VueTypes.string.isRequired,
        },
        computed: {
            bg(){
                return `background-image: url(${this.img});`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use "~@scss/components/PageContainer" as *;
</style>